import React from 'react'
import PropTypes from 'prop-types'
import { Flex, getPaletteColor } from 'pcln-design-system'
import styled, { css } from 'styled-components'

const focusAndHoverStyles = css`
  background-color: ${getPaletteColor('primary.base')};
`
const StyledItem = styled(Flex)`
  cursor: pointer;
  align-items: center;
  ${(props) =>
    !props.isMobile &&
    css`
      &:hover {
        ${focusAndHoverStyles};
      }
    `} &:focus {
    ${focusAndHoverStyles};
  }
`
const propTypes = {
  id: PropTypes.string.isRequired,
  item: PropTypes.any,
  isMobile: PropTypes.bool,
  onClick: PropTypes.func.isRequired,
  className: PropTypes.string,
  children: PropTypes.any.isRequired,
}

class DropdownItem extends React.Component {
  constructor(props) {
    super(props)

    this.handleClick = this.handleClick.bind(this)
  }

  handleClick(event) {
    if (this.props.onClick) this.props.onClick(this.props.item, event)
  }

  render() {
    return (
      <StyledItem
        id={this.props.id}
        onMouseDown={this.handleClick}
        width={1}
        isMobile={this.props.isMobile}
        m={0}
        data-testid='dropdown-item'
        className={this.props.className}
        role='option'
        pl={this.props.item?.type === 'NESTED_NEARBY_AIRPORT' ? 4 : 0}
      >
        {this.props.children}
      </StyledItem>
    )
  }
}

DropdownItem.propTypes = propTypes

export default DropdownItem
